import type { ResolvedTuningConfiguration, TuningIdentity } from '@playcastdotio/PeerCore';

export type TrialStateResetOptions = {
  cancelConnectionWork: (target: TuningIdentity) => Promise<void> | void;
  resetApplicationRecovery: (target: TuningIdentity) => Promise<void> | void;
  resetMeasurements: (target: TuningIdentity) => Promise<void> | void;
  captureChangeRequired: (target: TuningIdentity, configuration: ResolvedTuningConfiguration) => boolean;
  hasOtherCaptureConsumers: (target: TuningIdentity) => boolean;
  configureCapture: (target: TuningIdentity, configuration: ResolvedTuningConfiguration) => Promise<void>;
};

/** Called only at an explicit prepared trial boundary, never by ordinary reclaim. */
export class TrialStateReset {
  constructor(private readonly options: TrialStateResetOptions) {}

  async reset(target: TuningIdentity, configuration: ResolvedTuningConfiguration): Promise<void> {
    const changeSource = this.options.captureChangeRequired(target, configuration);
    if (changeSource && this.options.hasOtherCaptureConsumers(target)) throw new Error('Shared capture cannot change during this trial');
    await this.options.cancelConnectionWork(target);
    await this.options.resetApplicationRecovery(target);
    await this.options.resetMeasurements(target);
    if (changeSource) await this.options.configureCapture(target, configuration);
  }
}
